export default __webpack_public_path__ + "static/media/N.6b442136.svg";